
// @ is an alias to /src

import { streetService } from "@/services/street.service";
import StreetModel from "../models/street";
import {Component, Vue, Watch} from "vue-property-decorator";
import { VForm } from '@/types';
import { authService } from "@/services/authentification.service";
import ConfirmComponent from "@/components/ConfirmComponent.vue";
import {Filter, Sort} from "@/models/common";
import { DataOptions } from "vuetify";
import { debounce } from "@/utils/debounce";

@Component({
  components: { ConfirmComponent }
})
export default class Street extends Vue {
  private streets: Array<StreetModel> = new Array<StreetModel>();
  private editedItem = new StreetModel();
  private defaultItem = new StreetModel();

  private displayEditDialog = false;
  private displayConfirmDialog = false;
  private editedIndex = -1;
  private totalStreets = 0;
  private loading = true;

  private saveLoading = false;
  private deleteLoading = false;

  private searchStreet = "";

  private pagination = {
    page: 1,
    itemsPerPage: 50,
    pageStart: 0,
    pageStop: 50,
    pageCount: 0,
    itemsLength: 0,
  };

  private options: DataOptions = {
    itemsPerPage: 50,
    page: 1,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false
  };

  private headers = [
    { text: "Название", value: "name", sortable: true },
    { text: "Действия", value: "actions", sortable: false },
  ];

  private valid = true;

  async mounted() {
    const employee = await authService.getCurrentUser();
    if (employee?.role?.name === "Root") {
      this.headers.unshift({text: "Ид", sortable: false, value: "id"});
    }
  }

  getFilters(){
    const filters = new Array<Filter>();
    if (this.searchStreet)
      filters.push({field: "name", value: this.searchStreet});

    return filters;
  }

  getSorts(){
    const {sortBy, sortDesc} = this.options;

    const sortField = sortBy[0]
        ? sortBy[0].slice(0, 1).toUpperCase() + sortBy[0].slice(1)
        : null;
    const sortOrder = sortDesc[0] == false ? 1 : 0;
    const sorts = new Array<Sort>();
    if(sortField != null)
      sorts.push({field: sortField, order: sortOrder});
    return sorts;
  }

  @Watch("searchStreet")
  @Watch("options", {deep: true})
  debouncedloadStreets = debounce(this.loadStreets, 500);

  async loadStreets() {
    try {
      this.loading = true;

      const {page, itemsPerPage} = this.options;
      const offset = (page - 1) * itemsPerPage;
      const count = itemsPerPage == -1 ? this.totalStreets : itemsPerPage;
      const sorts = this.getSorts();
      const filters = this.getFilters();

      this.pagination.pageStart = offset;
      this.pagination.pageStop = offset + itemsPerPage;

      const res = await streetService.getPageData(offset, count, sorts, filters);
      this.streets = res.data.collection;
      this.totalStreets = res.data.count;
      this.pagination.itemsLength = res.data.count;
      this.pagination.pageCount = Math.ceil(res.data.count / 50);
    }
    catch (ex) {
      this.$toast.error("Ошибка при загрузке данных");
    }
    this.loading = false;
  }

  showEditDialog(item: StreetModel) {
    this.editedIndex = this.streets.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayEditDialog = true;
  }

  showDeleteDialog(item: StreetModel) {
    this.editedIndex = this.streets.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayConfirmDialog = true;
  }

  async deleteStreet() {
    try {
      this.deleteLoading = true;
      const item = this.editedItem;
      await streetService.delete(item.id);
      await this.loadStreets();
    }
    catch (ex) {
      this.$toast.error("Ошибка при удалении");
    }
    this.deleteLoading = false;
    this.close();
  }

  close() {
    this.displayConfirmDialog = false;
    this.displayEditDialog = false;
    this.form?.resetValidation();
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  get form(): VForm {
    return this.$refs.form as VForm;
  }

  async save() {
    this.form?.validate();
    if (this.valid) {
      this.saveLoading = true;
      const index = this.editedIndex;
      try {
        if (index > -1) {
          await streetService.update(this.editedItem);
        } else {
          await streetService.create(this.editedItem);
        }
        await this.loadStreets();
      }
      catch (ex) {
          this.$toast.error("Ошибка при сохранении");
      }
      this.saveLoading = false;
      this.close();
    }
  }
}
